import { ApplicationRef, ComponentFactoryResolver, Injectable, Injector, Type } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class ComponentInjectionService {
	constructor(private injector: Injector, private resolver: ComponentFactoryResolver, private app: ApplicationRef) { }

	addDynamicComponent = (component: Type<any>, target: any): void => {
		const factory = this.resolver.resolveComponentFactory(component);
		const newNode = document.createElement('div');
		const ref = factory.create(this.injector, [], newNode);

		ref.instance.target = target;

		this.app.attachView(ref.hostView);
	};
}
